import { render, staticRenderFns } from "./SendSpaceInfo.vue?vue&type=template&id=2147563f&scoped=true&"
import script from "./SendSpaceInfo.vue?vue&type=script&lang=js&"
export * from "./SendSpaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./SendSpaceInfo.vue?vue&type=style&index=0&id=2147563f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147563f",
  null
  
)

export default component.exports